
(function () {


angular
        .module('genesis_app')
        .run(run);

    run.$inject = ['authService'];

    function run(authService) {
        authService.setLoading(true);
        authService.handleAuthentication();
    }

})();



